import React from "react";
import classnames from "classnames";
import { Button, Card } from "components/UI";
import { bgCommunity } from "assets";
import { useNavigate } from "react-router-dom";
import { isProduction } from "utils/config";
import { BackgroundSection } from "../common";
import useCheckSignupPause from "hooks/useCheckSignupPause";

const VIDEO_URL = isProduction
  ? "https://www.youtube.com/embed/fFOH8VcERMo?autoplay=1&mute=1&playsinline=1"
  : "https://www.youtube.com/embed/fFOH8VcERMo?autoplay=1&mute=1&playsinline=1";

const HeroSection = () => {
  const navigate = useNavigate();
  const isPauseSignup = useCheckSignupPause();
  return (
    <div className="mt-24 md:mt-40">
      <BackgroundSection
        backgroundImage={`url(${bgCommunity.default})`}
        minHeight="640px"
        className="min-h-screen bg-no-repeat bg-cover xl:bg-full bg-center pt-10 px-4 sm:mb-10 md:-mb-16"
      >
        <div className="flex justify-center max-w-6xl mx-auto px-4 md:px-8">
          <div className="flex flex-col items-center justify-center">
          <div className="lg:col-span-3 mb-8 sm:m-0 relative rounded overflow-hidden">
              <iframe
                height="400"
                width="700"
                className="mx-auto lg:m-0"
                src={VIDEO_URL}
                title="landingVideo"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
            <Card
              className={classnames(
                "flex flex-col items-center justify-center text-center",
                "py-4 sm:py-12 px-4 sm:px-4 lg:py-8 sm:mx-12 sm:-mt-8 lg:mx-0 lg:my-12 lg:col-span-2",
                "rounded lg:rounded-l-none lg:rounded-tr",
              )}
            >
              {/* <h4>WHAT IS GIG LIFE PRO?</h4> */}
              <div className="w-full max-w-3xl mx-auto font-normal text-center space-y-5 leading-relaxed">
                <p>Gig Life Pro Creates Real Industry Access Across Asia-Pacific And Beyond</p>
                <p>Connecting Artists, Teams And Partners With Successful People In The Right Markets</p>
                <p>Empowering Them With Local Market And Broader Industry Information To Guide Their Growth</p>
                <p>We Are A Community Of People Who Are Growing The Music Business</p>
                <p>
                  Through Shared Experience And Valuable Opportunities<br />
                  Providing A Stage For People Who Have Run Successful Campaigns<br />
                  To Inform And Inspire Us All.
                </p>
              </div>
              {!isPauseSignup && <div className="mt-4 lg:mt-4">
                <Button
                  label="Partner With Us"
                  onClick={() => window.location.href = "https://hello.giglifepro.com/partnerships/"}
                  className="py-2 lg:py-4"

                />
              </div>}
            </Card>
          </div>
        </div>
      </BackgroundSection>
    </div>
  );
};

export default HeroSection;
